import { type FC, type ReactNode } from 'react';

import { Avatar } from '../Avatar';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { StarRating } from '../StarRating';
import { Text } from '../Typography';

export type UserCardProps = {
  avatarSrc?: string;
  title: string;
  subtitle?: string | ReactNode;
  rating?: number;
  showRating?: boolean;
  isVerified?: boolean;
  className?: string;
};

const UserCard: FC<UserCardProps> = ({
  avatarSrc,
  title,
  subtitle,
  rating,
  showRating = true,
  isVerified = false,
  className,
}) => {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      gap="var(--spacing-4)"
      className={className}
    >
      <Box display="flex" alignItems="flex-start" gap="var(--spacing-4)">
        <Avatar
          type={avatarSrc ? 'image' : 'text'}
          size="lg"
          src={avatarSrc}
          text={title}
          alt={`${title}'s avatar`}
        />

        <Box display="flex" flexDirection="column" gap="2px">
          <Text size="md" fontWeight="bold">
            {title}
          </Text>
          {subtitle &&
            (typeof subtitle === 'string' ? (
              <Text size="sm" color="text-secondary">
                {subtitle}
              </Text>
            ) : (
              subtitle
            ))}

          {showRating && rating !== undefined && <StarRating rating={rating} />}
        </Box>
      </Box>

      {isVerified && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="var(--spacing-1)"
          flexShrink={0}
        >
          <Icon variant="ShieldCheckSolid" fill="var(--icon-success)" />
          <Text size="xs" fontWeight="bold" color="text-primary">
            Verified
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default UserCard;
